var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.426,1.66H4.661c-1.657,0-3,1.343-3,3v14.765c0,1.657,1.343,3,3,3h14.765c1.657,0,3-1.343,3-3V4.66c0-1.657-1.343-3-3-3ZM7.795,19.281h-3.074v-9.872h3.074v9.872Zm-1.535-11.209s-.008,0-.012,0c-.981-.009-1.77-.812-1.761-1.793,0-.002,0-.004,0-.006.007-.986.813-1.78,1.799-1.773.986.007,1.78.813,1.773,1.799-.007.986-.813,1.78-1.799,1.773Zm9.96,11.21v-4.8c0-1.144-.028-2.62-1.6-2.62-1.6,0-1.834,1.255-1.834,2.537v4.88h-3.061v-9.87h2.935v1.349h.033c.601-1.022,1.715-1.631,2.9-1.586,3.116,0,3.681,2.04,3.681,4.7l.007,5.41h-3.061Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin);
export default __webpack_public_path__ + "static/media/social-linkedin.da4dec5083cc7db9da00200086f1d418.svg";
export { ForwardRef as ReactComponent };